// 气象站点Id
export const STATION_ID = "57874";
// 国家站
// 经度
export const LON = 112.3942;
// 纬度
export const LAT = 26.28;
export const ADMINCODE = 610523;

export const WECHAT_APPID = "wx0ac67228b99edf08";
export const WECAHT_NAME = "同州天气"
export const IMG_URL = "http://123.56.205.104:8000/tongzhou_wechat.jpg"

export const XKZ_RADAR_COLOR_GROUP = [
  // [-5, 0, 0, 172, 164],
  // [0, 5, 192, 192, 254],
  // [5, 10, 122, 114, 238],
  // [10, 15, 30, 38, 208],
  // [15, 20, 166, 252, 168],
  // [20, 25, 0, 234, 0],
  // [25, 30, 16, 146, 26],
  // [30, 35, 252, 244, 100],
  // [35, 40, 200, 200, 2],
  // [40, 45, 140, 140, 0],
  // [45, 50, 254, 172, 172],
  // [50, 55, 254, 100, 86],
  // [55, 60, 238, 2, 48],
  // [60, 65, 212, 142, 254],
  // [65, 100, 170, 36, 250],
  [5, 10, 65, 157, 241],
  [10, 15, 100, 231, 235],
  [15, 20, 109, 250, 61],
  [20, 25, 0, 216, 0],
  [25, 30, 1, 144, 0],
  [30, 35, 255, 255, 0],
  [35, 40, 231, 192, 0],
  [40, 45, 255, 144, 0],
  [45, 50, 255, 0, 0],
  [50, 55, 214, 0, 0],
  [55, 60, 192, 0, 0],
  [60, 65, 255, 0, 240],
  [65, 70, 150, 0, 180],
  [70, 100, 173, 144, 240],


];
